import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

export const LogoSkelton = () => (
  <Skeleton
    variant="rectangular"
    sx={{
      backgroundColor: "rgba(255,255,255,0.3)",
      borderRadius: "0.3rem",
    }}
    width={260}
    height={50}
  />
);
export const NavigationSkelton = () => (
  <Skeleton
    variant="rectangular"
    sx={{
      backgroundColor: "rgba(255,255,255,0.3)",
      borderRadius: "0.3rem",
      marginTop: "1.5rem",
    }}
    width={380}
    height={30}
  />
);

export const UserInfoSkeleton = () => (
  <Box
    sx={{
      flexBasis: "17.5%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "0.5rem",
    }}
  >
    <Skeleton
      variant="circular"
      sx={{ backgroundColor: "rgba(255,255,255,0.3)" }}
      width={40}
      height={40}
    />
    <Skeleton
      sx={{ backgroundColor: "rgba(255,255,255,0.3)" }}
      width={130}
      height={27}
    />
  </Box>
);

export const LegacyTextSkeleton = () => (
  <Skeleton
    sx={{
      backgroundColor: "rgba(255,255,255,0.3)",
    }}
    width={30}
    height={37}
  />
);
